package pl.decks.chartjs.style

import pl.decks.chartjs.model.JSEnum

sealed class PointStyle {
    data class Shaped(val style: Shape) : PointStyle()
    object None : PointStyle()

    @Suppress("unused")
    enum class Shape(override val jsValue: String) : JSEnum {
        Circle("circle"),
        Cross("cross"),
        CrossRot("crossRot"),
        Dash("dash"),
        Line("line"),
        Rect("rect"),
        RectRounded("rectRounded"),
        RectRot("rectRot"),
        Star("star"),
        Triangle("triangle"),
    }

    internal fun toChartJs() : dynamic = when (this) {
        is None -> false.asDynamic()
        is Shaped -> style.toChartJs()
    }
}
